
import { defineComponent, PropType } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
        isInvoices: {
            type: Boolean,
            default: false,
        },
    },
    components: { Cheap },
    setup() {
        return {
            formatDateWithTimeFromBackend
        }
    }
})
